<template>
  <div>
    <Accordeon title="Was wird bei der Kartenansicht gespeichert?">
      <template slot="answer">
        <ul>
          <li>Der Kartenausschnitt, der aktuell dargestellt wird.</li>
          <li>Aktuell eingeblendete Verkehrsinformationen.</li>
          <li>Filtereinstellungen für E-Tankstellen.</li>
          <li>
            Bitte beachten Sie, dass diese Einstellungen nicht dauerthaft gespeichert werden.
            Dafür und zum Übertragen der Daten auf andere Geräte von Ihnen, müssten Sie ein Profil anlegen.
            Lesen Sie mehr dazu unter "Meine Einstellungen sind verschwunden".
          </li>
          <li>
            Aufrufen können Sie die Einstellungen über den Knopf im Bereich "Mein Verkehrsservice".
            Beim nächsten Start wird die gespeicherte Kartenansicht automatisch aufgerufen.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon
      title="Warum kann ich nicht meine genaue Adresse beim Anlegen einer Route hinterlegen?"
    >
      <template slot="answer">
        <ul>
          <li>
            Der Verkehrsservice berücksichtigt hessische Autobahnen und große Bundesstraßen,
            die in der Zuständigkeit von Hessen Mobil und der Verkehrszentrale Hessen liegen.
            Daher werden beim Anlegen der Route nur Autobahnanschlüsse als Start- und Zielpunkte angeboten.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon
      title="Warum kann ich keine Benachrichtigungen zu meinen Routen auf dem Desktop oder Laptop aktivieren?"
    >
      <template slot="answer">
        <ul>
          <li>Die Benachrichtigungsfunktion funktioniert nur auf mobilen Geräten.</li>
          <li>
            Ihre Einstellungen auf dem Laptop oder Desktop PC können Sie auf Ihre mobilen Geräte übertragen,
            wenn Sie sich Ihr Profil speichern.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Wann und wie oft bekomme ich eine Benachrichtigung zu meinen Strecken?">
      <template slot="answer">
        <ul>
          <li>
            Eine Benachrichtigung erhalten Sie immer,
            wenn es eine Verkehrsmeldung zu Ihrer Strecke gibt und wenn sich diese verändert,
            beispielsweise bei einem Anstieg des Reisezeitverlustes.
            Diese Nachrichten erhalten Sie nicht häufiger als alle 5 Minuten;
            dieser Benachrichtigungsintervall ist voreingestellt.
          </li>
          <li>
            Sie können den Benachrichtigungsintervall auch selbst bestimmen,
            in dem Sie in den Einstellungen einen der vorgegebenen Werte (5, 10, 15 oder 20 min.) auswählen.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Die Verzögerung auf meiner Strecke war anders als angegeben.">
      <template slot="answer">
        <ul>
          <li>
            Dafür kann es verschiedene Gründe geben.
            Eventuell hat sich die Störung in der Zwischenzeit verlagert bzw.
            das Ausmaß verändert oder Ihre Strecke ist nur teilweise von einem Stau betroffen.
            Aus technischen Gründen können keine Verzögerung auf Teilstrecken einer Störung abgebildet werden.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Meine Einstellungen sind verschwunden.">
      <template slot="answer">
        <ul>
          <li>Haben Sie den Cache des Browsers gelöscht?</li>
          <li>Haben Sie “Privates Surfen” oder eine vergleichbare Einstellung vorgenommen?</li>
          <li>
            Wenn Sie Ihr Nutzerprofil gespeichert haben, können Sie die Einstellungen wieder aufrufen.
            Folgen Sie dem entsprechenden Hinweis im Bereich “Mein Verkehrsservice”.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Was passiert, wenn ich kein Profil anlege?">
      <template slot="answer">
        <ul>
          <li>
            Ihre Einstellungen werden in einem LocalStorage auf Ihrem Gerät gespeichert.
            Wenn Sie die Speicherung im LocalStorage nicht zulassen
            (zum Beispiel, weil Sie die Website im “privaten Modus” aufrufen),
            die Browserdaten löschen oder bei einem Systemabsturz,
            müssen Sie die Einstellungen neu vornehmen.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Warum sollte ich ein Profil anlegen? ">
      <template slot="answer">
        <ul>
          <li>
            Um Ihre Einstellungen dauerhaft wiederherstellen und auf andere Geräte von Ihnen
            übertragen zu können, müssen Sie ein Profil anlegen.
          </li>
          <li>
            Wenn Sie Ihr Profil auf mehreren Geräten aktiviert haben
            (durch Eingabe Ihrer Profilnummer und Ihres Passwortes),
            werden Änderungen und Ergänzungen auf allen Geräten synchronisiert.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Welche Daten werden in meinem Profil gespeichert?">
      <template slot="answer">
        <ul>
          <li>
            Der Schutz Ihrer persönlichen Daten ist uns wichtig.
            Wir speichern daher keine personalisierten Daten.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Ich weiß Profilnummer oder Passwort nicht mehr.">
      <template slot="answer">
        <ul>
          <li>
            Wir speichern Ihre Daten nicht.
            Vielleicht haben Sie sich eine Erinnerungsmail beim Anlegen Ihres Nutzerprofils zusenden lassen.
            Falls nicht, müssen Sie Ihre Einstellungen erneut vornehmen.
          </li>
        </ul>
      </template>
    </Accordeon>

    <Accordeon title="Was ist der Push-Notifier und wie wird er installiert?">
      <template slot="answer">
        <ul>
          <li>
            Bei manchen mobilen Geräten funktioniert die automatische Benachrichtigungsfunktion
            bisher nur nach der Installation des Programms Push-Notifier.
            Zum Beispiel beim iPhone und iPad.
          </li>
          <li>Hessen Mobil übernimmt keine Verantwortung für die Nutzung des Push-Notifiers.</li>
          <li>Das sind die Schritte zur Installation:</li>
        </ul>
        <ul class="numbered">
          <li>
            Gehen Sie auf die Webseite
            <a
              class="colorBlue"
              rel="noopener noreferrer"
              href="https://www.pushnotifier.de"
              target="_blank"
            >www.pushnotifier.de</a>.
          </li>
          <li>
            Unter dem Menüpunkt „Sign Up“ können Sie einen Benutzernamen (Username)
            und ein Passwort selbst festlegen.
            Merken Sie Sie sich diese beiden Angaben.
          </li>
          <li>
            Auf der Folgeseite hinterlegen Sie eine Sicherheitsfrage und ein Muster.
            Damit können Sie auf den Service zugreifen, wenn Sie das Passwort vergessen haben.
            Lesen und bestätigen Sie die Nutzungsbedingungen (terms of use).
          </li>
          <li>
            Sie erhalten nun eine Email an die von Ihnen angegebene Adresse.
            Klicken Sie auf Confirm (bestätigen).
          </li>
          <li>
            Als nächstes laden Sie die App „pushnotifier“ im AppStore auf Ihr Mobilgerät herunter,
            geben Benutzernamen und Passwort ein und erlauben den Erhalt von Benachrichtigungen
            im erscheinenden Dialogfenster.
          </li>
          <li>
            Die gleichen PushNotifier-Anmeldedaten geben Sie auf Ihrem Mobilgerät im Verkehrsservice ein.
            Die entsprechenden Felder erscheinen bei Klick auf „Benachrichtigung“.
          </li>
          <li>
            Nach dem anmelden erhalten Sie sofort eine Meldung,
            dass die Benachrichtigungen erfolgreich abonniert sind.
          </li>
        </ul>
        <ul>
          <li>
            Überprüfen Sie die Einstellungen bei „Benachrichtigungen“,
            ob die Zeiträume und Benachrichtigungsintervalle
            Ihren Vorstellungen entsprechen und ob die Benachrichtigungsfunktionen aktiviert sind.
          </li>
        </ul>
      </template>
    </Accordeon>
  </div>
</template>

<script>
import Accordeon from './../../CoreComponents/Accordeon.vue';
export default {
  name: `FAQHaeufigeFragen`,
  components: { Accordeon }
};
</script>

<style scoped>
</style>
